import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import UnlinkedApplicationAutoVehicleEditVin from "./vin";
import UnlinkedApplicationAutoVehiclesEditMake from "./make";
import UnlinkedApplicationAutoVehiclesEditModel from "./model";
import UnlinkedApplicationAutoVehiclesEditStatus from "./status";
import UnlinkedApplicationAutoVehiclesEditTrim from "./trim";
import UnlinkedApplicationAutoVehiclesEditYear from "./year";
import UnlinkedApplicationAutoVehiclesFullCoverage from "./full-coverage";
export default function UnlinkedApplicationAutoVehicleEdit() {
    var path = useRouteMatch().path;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "".concat(path, "/year"), component: UnlinkedApplicationAutoVehiclesEditYear }),
        React.createElement(Route, { path: "".concat(path, "/make"), component: UnlinkedApplicationAutoVehiclesEditMake }),
        React.createElement(Route, { path: "".concat(path, "/model"), component: UnlinkedApplicationAutoVehiclesEditModel }),
        React.createElement(Route, { path: "".concat(path, "/trim"), component: UnlinkedApplicationAutoVehiclesEditTrim }),
        React.createElement(Route, { path: "".concat(path, "/status"), component: UnlinkedApplicationAutoVehiclesEditStatus }),
        React.createElement(Route, { path: "".concat(path, "/full-coverage") },
            React.createElement(UnlinkedApplicationAutoVehiclesFullCoverage, null)),
        React.createElement(Route, { path: "".concat(path, "/vin") },
            React.createElement(UnlinkedApplicationAutoVehicleEditVin, null))));
}
